// extracted by mini-css-extract-plugin
module.exports =  {"btnGroupRight":"sDYigLSDgIzi4EegZHWL","btnGroupLeft":"ycAlnpnss276m_gHV_rI"};